// HomeWeb.jsx
import React, {useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { useLogScreen } from '../useLogScreen';

export default function DilWeb() {
    useLogScreen('DilView');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Precificador';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();

    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Precificador</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    
                                    Quer descobrir quanto vale o seu imóvel?{'\n\n'}
                                    Com a nossa IA, o preço de cada imóvel é calculado com base em dados reais:{'\n'}
                                    • Volume de imóveis anunciados e vendidos no bairro{'\n'}
                                    • Valorização do m² na região{'\n'}
                                    • Perfil médio de moradores da região{'\n'}
                                    • Valor de mercado estimado do imóvel{'\n\n'}
                                    Gere seu laudo avaliativo e tenha acesso a um estudo de mercado completo!
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => Linking.openURL('https://cdn.imogo.com.br/manuais/manual_celer_imogo.pdf')}>
                                        <Image
                                            source={require('../assets/icons/info.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Manual do precificador</Text>
                                        </View>
                                    </TouchableOpacity>                                   

                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('PrecificadorWeb', { usuario_id })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Gerar laudo avaliativo</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}